import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FlexBox } from 'components/Box'
import { Switch } from 'components/Form'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { Alert } from 'features/alerts/types/alert'
import { AddEditAdUnitContext } from 'features/inventory/ad-unit/contexts/AddEditAdUnitContext'
import { useAbility } from 'providers/casl'
import { AdUnitAlerts } from '../../components/AdUnitAlerts'
import { AdUnitAlert } from '../../types/adUnitAlert'
import { Schema } from './schema'

export const CommonForm = (): JSX.Element => {
  const { t } = useTranslation('features/adUnit')
  const { adUnit } = useContext(AddEditAdUnitContext)
  const { control } = useFormContext<Schema>()
  const ability = useAbility()
  const cannotUpdateAdUnit = ability.cannot('update', 'AdUnit')

  if (!adUnit) {
    throw Error('Ad unit should be accessible')
  }

  const { alerts } = adUnit

  const unfilledRecoveryAlerts: Alert<AdUnitAlert>[] = alerts.filter(
    (alert: Alert<AdUnitAlert>): boolean => alert.name.startsWith('unfilledRecovery'),
  )

  return (
    <Paper>
      <SectionHeader
        subtitle={t('form.unfilledRecovery.enabled.description')}
        title={t('form.unfilledRecovery.enabled.title')}
        titleEndAdornment={
          <FlexBox axis='x'>
            <Switch
              control={control}
              disabled={cannotUpdateAdUnit}
              name='unfilledRecoveryEnabled'
            />

            {unfilledRecoveryAlerts.length > 0 && <AdUnitAlerts alerts={unfilledRecoveryAlerts} />}
          </FlexBox>
        }
      />
    </Paper>
  )
}
